// Single source of truth for the user-management role list.
//
// This was previously hand-duplicated (values, labels, and the
// WhatsApp-access allow-list) across edituser.jsx, addusers.jsx and
// feature-module/usermanagement/users.jsx. None of those files used
// react-i18next `t(...)` keys for the per-role labels -- they built the
// bilingual strings inline (`lang === 'fr' ? '...' : '...'`) -- so this
// module reproduces that same literal-string approach rather than
// inventing new i18n keys.
//
// Keep new roles distinct from existing roles to preserve their permissions.

export const canMakeSales = (role) =>
    ['su', 'admin', 'compta', 'rh', 'manager', 'salon_manager'].includes(role);

export const canDeleteInvoices = (role) =>
    ['su', 'admin', 'compta', 'rh'].includes(role);

export const ROLES = [
    { value: 'su', labelFr: 'Super Admin', labelEn: 'Super Admin', selectable: false },
    { value: 'admin', labelFr: 'Admin', labelEn: 'Admin', selectable: false },
    { value: 'compta', labelFr: 'Comptable', labelEn: 'Accountant', selectable: true },
    { value: 'rh', labelFr: 'RH', labelEn: 'HR', selectable: true },
    { value: 'logistic', labelFr: 'Logistique', labelEn: 'Logistics', selectable: true },
    { value: 'salon_manager', labelFr: 'Caissière', labelEn: 'Cashier', selectable: true },
    { value: 'manager', labelFr: 'Manager', labelEn: 'Manager', selectable: true },
    { value: 'com', labelFr: 'Commercial', labelEn: 'Sales', selectable: true },
];

// Roles offered by the "add user" / "edit user" role dropdowns.
// `su` and `admin` are intentionally excluded, matching the original
// `roleOptions` / `status` arrays in edituser.jsx and addusers.jsx.
export const getRoleOptions = (lang) =>
    ROLES.filter((role) => role.selectable).map((role) => ({
        value: role.value,
        label: lang === 'fr' ? role.labelFr : role.labelEn,
    }));

// Looks up the display label for a role value. Returns `undefined` when the
// role isn't found so callers can apply their own fallback (e.g. "Unknown").
export const getRoleLabel = (value, lang) => {
    const role = ROLES.find((r) => r.value === value);
    if (!role) return undefined;
    return lang === 'fr' ? role.labelFr : role.labelEn;
};

// Keep in sync with sidebar_data.js / router.link.jsx: these roles already
// get WhatsApp inbox access regardless of the per-user flag.
export const ROLES_WITH_WHATSAPP_ACCESS = ['su', 'admin', 'manager', 'com'];
